<script setup>
import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import UsersIcon from '@/icons/UsersIcon'
import { formatDate } from '@/Mixins/FormatsDates'

import { computed } from 'vue'

const props = defineProps({
	organisation: {
		type: Object,
		default: null,
	},
})

const membership_level = computed(() => {
	if (props.organisation === null) return ''
	return props.organisation.membership_level.toUpperCase()
})

</script>
<template>
	<DashboardStatsUserCard :icon="UsersIcon" :data="organisation.users.length" caption="Contacts">
		<div class="text-center flex flex-col" >
			<h1 class="text-5xl">{{organisation.users.length}}</h1>
			<p>Contacts</p>
		</div>
		<template #footer>
			<!-- link to contacts section -->
			<Button
				color="blue"
				variant="link"
				href="/contacts"
			>
				Manage Contacts
			</Button>
		</template>
	</DashboardStatsUserCard>
</template>